
import { useEffect, useState } from 'react'
import { ReactSession } from 'react-client-session';
import TokenCreatorFactory from '../config/abi/TokenCreatorFactory.json';
import StandardToken from '../config/abi/StandardToken.json';
import StandardTokenMintable from '../config/abi/StandardTokenMintable.json';
import LiquidityGenerator from '../config/abi/LiquidityGenerator.json';
import LiquidityGeneratorBurnable from '../config/abi/LiquidityGeneratorBurnable.json';

import Contracts from '../config/Contracts.json';
import useWeb3 from '../hooks/useWeb3'
import { useWallet } from "@binance-chain/bsc-use-wallet";

const selectedFactory = ()=>{
  const Factory = Contracts.find(network => network.chain === ReactSession.get("network").networkname);
  return Factory.factory;
}

 

export const CreateFees = ()=>{
    const web3 = useWeb3();
    const [data, setdata] = useState([]);


    useEffect(() => {
        async function address() {
        const contracts = new web3.eth.Contract(TokenCreatorFactory, selectedFactory());
        const standardTokenPrice = await contracts.methods.StandardTokenPrice().call();
        const standardMintableTokenPrice = await contracts.methods.StandardMintableTokenPrice().call();
        const LiquidityGeneratorPrice = await contracts.methods.LiquidityGeneratorPrice().call();
        const LiquidityGeneratorBurnPrice = await contracts.methods.LiquidityGeneratorBurnPrice().call();  
        let fees =[];
        fees.push(standardTokenPrice);
        fees.push(standardMintableTokenPrice);
        fees.push(LiquidityGeneratorPrice);
        fees.push(LiquidityGeneratorBurnPrice);
            setdata(fees);  
        }
        address();
        }, [])
        return data;
  }

export const CreateFeesAVAX = ()=>{
    const web3 = useWeb3();
    const [data, setdata] = useState([]);


    useEffect(() => {
        async function address() {
        const contracts = new web3.eth.Contract(TokenCreatorFactory, selectedFactory());
        const standardTokenPrice = await contracts.methods.StandardTokenPrice().call();
        const standardMintableTokenPrice = await contracts.methods.StandardMintableTokenPrice().call();
        let fees =[];
        fees.push(standardTokenPrice);
        fees.push(standardMintableTokenPrice);
            setdata(fees);  
        }
        address();
        }, [])
        return data;
  }
  
 

  export const RefEarnedBalance = ()=>{
    const web3 = useWeb3();
    const [data, setdata] = useState(0);
    const { account } = useWallet();

    useEffect(() => {
        async function address() {
        const contracts = new web3.eth.Contract(TokenCreatorFactory, selectedFactory());
       let totalCreated;
       if(account){
        totalCreated = await contracts.methods._refEarnedBalance(account).call();
       }else{
        totalCreated = 0;
       }
            setdata(totalCreated);  
        }
        address();
        }, [account])
        return data;
  }

  export const TotalCreatedCount = ()=>{
    const web3 = useWeb3();
    const [data, setdata] = useState(0);

    useEffect(() => {
        async function address() {
        const contracts = new web3.eth.Contract(TokenCreatorFactory, selectedFactory());
        const totalCreated = await contracts.methods.tokenID().call();
            setdata(totalCreated);  
        }
        address();
        }, [])
        return data;
  }

  export const UserCreatedTokensList = ()=>{
    const web3 = useWeb3();
    const [data, setdata] = useState([]);
    const { account } = useWallet();

    useEffect(() => {
        async function address() {
        const contracts = new web3.eth.Contract(TokenCreatorFactory, selectedFactory());
         
        let totalCreated =[];

        if(account){
            totalCreated = await contracts.methods.getuserCreatedTokenList(account).call();
        }
            let contractList = [];
            for(let a = 0; a < totalCreated.length; a++){  

                const contractAddress = await contracts.methods.createdTokens(totalCreated[a]).call();
                let  contractWeb3 = new web3.eth.Contract(StandardToken, contractAddress);
                    contractList.push({"id":totalCreated[a],
                    "contract":contractAddress,
                    "name": await contractWeb3.methods.name().call() , 
                    "symbol": await contractWeb3.methods.symbol().call(),
                    "decimal":await contractWeb3.methods.decimals().call(),
                    "totalsupply":await contractWeb3.methods.totalSupply().call() 
                    });
              }
            setdata(contractList); 
        }
        address();
        }, [account])
        return data;
  }

  export const UserCreatedNumberofTokens = ()=>{
    const web3 = useWeb3();
    const [data, setdata] = useState([]);
    const { account } = useWallet();

    useEffect(() => {
        async function address() {
        const contracts = new web3.eth.Contract(TokenCreatorFactory, selectedFactory());
         
        let totalCreated =[];

        if(account){
            totalCreated = await contracts.methods.getuserCreatedTokenList(account).call();
        }
            setdata(totalCreated.length); 
        }
        address();
        }, [account])
        return data;
  }

  export const ContractInfo = (contractAddr)=>{
    const web3 = useWeb3();
    const [data, setdata] = useState({});
    const { account } = useWallet();

    useEffect(() => {
        async function address() {
          const contracts = new web3.eth.Contract(TokenCreatorFactory, selectedFactory());
         
          const tokenType = await contracts.methods.tokenType(contractAddr).call();

          let contractCall;
          let otherData={};

          if(tokenType == 1){
            contractCall = new web3.eth.Contract(StandardToken, contractAddr);
            otherData = {
                "owner" : await contractCall.methods._owner().call()
            }
          }else if(tokenType == 2){
            contractCall = new web3.eth.Contract(StandardTokenMintable, contractAddr);
            otherData = {
                "owner" : await contractCall.methods._owner().call()
            }
          }else if(tokenType==3){
            contractCall = new web3.eth.Contract(LiquidityGenerator, contractAddr);
            otherData = {
              "maxFee": await contractCall.methods.MAX_FEE().call(),
              "burnFee": 0,
              "liqFee" : await contractCall.methods._liquidityFee().call(),
              "marketingFee" : await contractCall.methods._marketingFee().call(), 
              "taxFee" : await contractCall.methods._taxFee().call(),
              "marketingWallet" : await contractCall.methods.marketingWallet().call(),
              "owner" : await contractCall.methods.owner().call(),
              "uniswapV2Router" : await contractCall.methods.uniswapV2Router().call(),
              "uniswapV2Pair" : await contractCall.methods.uniswapV2Pair().call(),
              "deadAddress" : 0,
          }
          }else if(tokenType==4){
            contractCall = new web3.eth.Contract(LiquidityGeneratorBurnable, contractAddr);
            otherData = {
                "maxFee": await contractCall.methods.MAX_FEE().call(),
                "burnFee": await contractCall.methods._burnFee().call(),
                "liqFee" : await contractCall.methods._liquidityFee().call(),
                "marketingFee" : await contractCall.methods._marketingFee().call(), 
                "taxFee" : await contractCall.methods._taxFee().call(),
                "marketingWallet" : await contractCall.methods.marketingWallet().call(),
                "owner" : await contractCall.methods.owner().call(),
                "uniswapV2Router" : await contractCall.methods.uniswapV2Router().call(),
                "uniswapV2Pair" : await contractCall.methods.uniswapV2Pair().call(),
                "deadAddress" : await contractCall.methods.deadAddress().call(),
            }
             
          }

          let contractInfo = {"name": await contractCall.methods.name().call(),
          "symbol":await contractCall.methods.symbol().call(),
          "decimal":await contractCall.methods.decimals().call(),
          "totalsupply":await contractCall.methods.totalSupply().call()};

           
          const contractData = {
            "tokenType" : tokenType,
            "tokenInfo" : contractInfo,
             "detail" : otherData
          };

          setdata(contractData); 
        }
        address();
        }, [account])
        return data;
  }

  export const IsCreatedHere = (contractAddr)=>{
    const web3 = useWeb3();
    const [data, setdata] = useState(true);
 

    useEffect(() => {
        async function address() {
          const contracts = new web3.eth.Contract(TokenCreatorFactory, selectedFactory());
         
          const isCreated = await contracts.methods.isCreatedHere(contractAddr).call();
  
          setdata(isCreated); 
        }
        address();
        }, [])
        return data;
  }


export default CreateFees;
